var _defs, _line, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPoAgents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n                fill: none;\n                stroke: white;\n                stroke-linecap: round;\n                stroke-linejoin: round;\n                stroke-width: 2.5px;\n            }\n        "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "customs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 28.03,
    y1: 37.09,
    x2: 20.78,
    y2: 48.33
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.1,31.06s.86,3.56-1.72,5.08S8.5,39.69,8.07,42.74a20.27,20.27,0,0,0,0,5.59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.73,19.35c0,4.46,1.12,12.82,7.28,12.82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.65,31.06s-.86,3.56,1.72,5.08,6.88,3.56,7.31,6.61a20.27,20.27,0,0,1,0,5.59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28,19.35c0,4.46-1.12,12.82-7.28,12.82"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.24,27.47a5.43,5.43,0,0,1-4.48,0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.77,9.45c2.56,0,3.76,2.64,6.62,3.52s3.91,1,4.07,1.91-1.81,1.76-2.11,2.49a1.94,1.94,0,0,0-.07.21,1.72,1.72,0,0,1-1.43,1.2,53.27,53.27,0,0,1-7.08.64h0a53.27,53.27,0,0,1-7.08-.64,1.72,1.72,0,0,1-1.43-1.2,1.94,1.94,0,0,0-.07-.21c-.3-.73-2.26-1.61-2.11-2.49s1.2-1,4.07-1.91,4.07-3.52,6.62-3.52Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.7,18.84s1.2,3.81,7.08,3.81,7.08-3.81,7.08-3.81"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.67,
    y: 44.2,
    width: 14.51,
    height: 4.14
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.44,38.67l-5-4.92a3.76,3.76,0,0,0-5.27,0l-.33.32L53.11,44.2l.33-.32A3.65,3.65,0,0,0,53.44,38.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPoAgents);
export default __webpack_public_path__ + "static/media/iconPoAgents.a4ae9814abc1078f5e63b3eeed7bd489.svg";
export { ForwardRef as ReactComponent };